import { render, staticRenderFns } from "./PopularMoive.vue?vue&type=template&id=6f23ef92&scoped=true&"
import script from "./PopularMoive.vue?vue&type=script&lang=js&"
export * from "./PopularMoive.vue?vue&type=script&lang=js&"
import style0 from "./PopularMoive.vue?vue&type=style&index=0&id=6f23ef92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f23ef92",
  null
  
)

export default component.exports